import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Ng2SearchPipe } from './filter.pipe';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { NgxPaginationModule} from 'ngx-pagination';

import { NotificationsComponent } from './notifications.component';
import { NotificationsService } from './notifications.service';

@NgModule({
  declarations: [
    NotificationsComponent,
    Ng2SearchPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    Ng2OrderModule,
    NgxPaginationModule
  ],
  providers: [NotificationsService],
  bootstrap: [NotificationsComponent],
  exports: [Ng2SearchPipe]
})
export class NotificationsModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/notifications/notifications.module.ts